<div class="main-container">
    <div class="top-menu">
        <div class="logo-container">
            <a routerLink="/" class="logo-link" aria-label="Home">
                <img src="../../../assets/images/gazooky-timewalks-side.svg" class="logo-svg" alt="Gazooky TimeWalks Logo" />
            </a>
        </div>
        <button pButton pRipple icon="pi pi-user" class="p-button-text no-label account-button" (click)="manageUser($event)" #accountBtn>
        </button>
        <p-menu #accountMenu [model]="accountMenuItems" [popup]="true" appendTo="body"></p-menu>
    </div>
    <div class="content-container">
        <div>
            <router-outlet></router-outlet>
            <p-message *ngIf="!role" severity="warn" text="It looks like you don't have any permissions. Please get in touch with the administrator or try signing out and signing back in."></p-message>
        </div>
    </div>
</div>